import { defineStore } from "pinia"
import { useRoute } from "vue-router"
import router from "./router.js"
import FeedService from "../services/FeedService.js"

export const useFilteredFeedStore = defineStore("filteredFeed", {
	state: () => ({
		endpoint: document.querySelector("#app").dataset.endpoint || "post",
		taxonomy: document.querySelector("#app").dataset.taxonomy || "categories",
		items: [],
		tmpItems: [],
		totalShowing: 0,
		isFiltered: false,
		isLoading: true,
		isUpdating: false,
		isPaging: false,
		isToggled: false,
		filters: {},
		filterLabels: [],
		filterMode: "single", // single/multi taxonomy option

		// Only for main feed
		page: 1,
		maxNumPages: null,
		foundPosts: null,
		messageNoResults: 'No results for this filter',
		messageLoading: 'Loading',
		featureButton: null,
		whatsOnBaseURL: null
	}),
	actions: {
		async initState() {
			const route = useRoute()
			if (route.query.length) {
				this.isFiltered = true
			}
			return route.query
		},
		setState() {
			router.push({ name: "home", query: this.filters })
		},
		updateFilters({ taxonomy, term }) {
			if (!this.filters[taxonomy]) {
				this.filters = {
					...this.filters,
					[taxonomy]: this.filterMode == "single" ? term : [term],
				}
			} else {
				if (this.filterMode == "single") {
					if (this.filters[taxonomy] == term || term === null ) {
						delete this.filters[taxonomy]
					} else {
						this.filters[taxonomy] = term
					}
				} else {
					if (typeof this.filters[taxonomy] === "string") {
						this.filters[taxonomy] = [this.filters[taxonomy]]
					}
					const index = this.filters[taxonomy].indexOf(term)
					if (index === -1) {
						this.filters[taxonomy].push(term)
					} else {
						this.filters[taxonomy].splice(index, 1)
						if (this.filters[taxonomy].length === 0) {
							delete this.filters[taxonomy]
						}
					}
				}
			}

			delete this.filters.page
			this.setState()
		},
		removeDateFilter() {
			// Just for removing date filter
			// Needs to be separate as it's only a single choice
			// Similar to a radio field rather than a checkbox
			delete this.filters.date
			this.setState()
		},
		async fetchItems() {
			this.isLoading = true
			
			if( this.items ){
				this.isUpdating = true
			}

			if( !this.isPaging ){
				this.items = []
				this.page = this.maxNumPages = 0
			}

			try {
				const response = await FeedService.getFeed(this.endpoint, {
					params: this.filters,
				})
				
				setTimeout(()=>{

					this.tmpItems = response.data.items || []

					if( this.isPaging ){
						this.items = this.items.concat( this.tmpItems )
						this.isPaging = false
					}else{
						this.items = this.tmpItems
					}

					this.page = response.data.page
					this.foundPosts = response.data.found_posts
					this.maxNumPages = response.data.max_num_pages
					this.isFiltered = Object.keys(this.filters).length > 0
					this.filterLabels = response.data.labels
					this.totalShowing = this.items.length

					this.isLoading = false
					this.isUpdating = false
				},500)

				// console.log( this.foundPosts )
			} catch (error) {
				console.log(error)
			}
		},
		nextPage() {
			this.isPaging = true
			this.filters.page = (this.filters.page ?? 1) + 1
			this.fetchItems()
		},
		clearFilters() {
			this.filters = {}
			this.filterLabels = []
			this.setState()
		},
		resetApp() {
			this.clearFilters()
			this.isFiltered = false
			this.fetchItems()
		},
		isFilterSet( taxonomy ) {
			const filters = this.filters
			return filters[taxonomy]
		},
		inFilters(term, taxonomy) {
			const filters = this.filters
			return filters[taxonomy] && ( filters[taxonomy] === term )
		},
	},
	getters: {
		noFilters: (state) => Object.keys(state.filters).length === 0,
		filterMessage: (state) => {
			let msg = [];
			if (state.filterLabels.length) {
				msg.push(`Filtering “${state.filterLabels.join("” “")}”`);
			}
			if (state.filters.keyword) {
				msg.push(`Keyword: “${state.filters.keyword}”`);
			}
			if (state.page !== state.maxNumPages && state.foundPosts) {
				msg.push(`Page ${state.page} of ${state.maxNumPages}`);
			}
			if (state.foundPosts) {
				msg.push(`${state.foundPosts} result${ state.foundPosts !== 1 ? 's' : '' }`);
			}
			return msg.join(" / ");
		},
		hasSingleTaxonomy: (state) => {
			return state.endpoint === "post"
		},
		hasMorePages: (state) => {
			return state.page < state.maxNumPages;
		},
		totalLeft: (state) => {
			return state.foundPosts - state.totalShowing
		}
	},
})
